import {
  IconPencil,
  IconTrash,
  Menu,
  MenuButton,
  MenuItem,
  useMenuState,
} from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Event, type DefaultProps } from 'typings'
import { ruleStackMessages } from '.'
import { useAnalytics } from 'use-analytics'

interface DefaultActionsProps extends DefaultProps {
  onEdit?: () => void
  onRemove: () => void
}

export function RuleDefaultActions(props: DefaultActionsProps) {
  const { onEdit, onRemove } = props
  const actionsState = useMenuState()
  const { formatMessage: i18n } = useIntl()

  const { track } = useAnalytics()

  return (
    <>
      <MenuButton
        state={actionsState}
        labelHidden
        variant="neutralTertiary"
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation()
        }}
      />
      <Menu
        state={actionsState}
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation()
        }}
      >
        {onEdit && (
          <MenuItem
            label={i18n(ruleStackMessages.edit)}
            icon={<IconPencil />}
            onClick={() => {
              track(Event.CARD_ACTION_EDIT_CLICK)
              onEdit()
            }}
          />
        )}
        <MenuItem
          label={i18n(ruleStackMessages.remove)}
          icon={<IconTrash />}
          onClick={onRemove}
          critical
        />
        {props.children}
      </Menu>
    </>
  )
}
